import { RichLanguageFormat } from "@dc-extension-rich-text/common";
var conf = {
    format: RichLanguageFormat.JSON
};
export default conf;
